import { render, staticRenderFns } from "./ProdEpiIsIn.vue?vue&type=template&id=169b2392&scoped=true&"
import script from "./ProdEpiIsIn.vue?vue&type=script&lang=js&"
export * from "./ProdEpiIsIn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169b2392",
  null
  
)

export default component.exports